import $ from "jquery";

const validators = {
    select: {
        parameters: ["search"],
        isValid: function (value, element, params) {
            if (params.search == "true") {
                var list = [];
                var listElement = $("#" + element.id + "_SearchList");
                listElement.children().each(function () {
                    list.push($(this).text());
                });

                return value == "" || list.includes(value);
            }

            return true;
        },
        unpack: function (options) {
            options.rules["select"] = options.params;
            options.messages["select"] = options.message;
        }
    }
};

function setupSelect() {
    $('[id$="_SearchList"]').each(function () {
        var inputElem = $("#" + this.id.replace("_SearchList", ""));
        var listElement = $(this);
        var listChildren = listElement.children('.list-group-item');

        inputElem.on("focus", function () {
            listElement.fadeIn("quick");
            filterListElements(listChildren, inputElem.val().toLowerCase())
        })

        inputElem.on("focusout", function () {
            listElement.fadeOut("quick");
        })

        inputElem.on("input", function (event) {
            filterListElements(listChildren, event.target.value.toLowerCase())
        })

        listChildren.on("mousedown ", function () {
            inputElem.val($(this).text());
        })
    })
}

function filterListElements(listElements, value) {
    var searchValue = (value || "").toLowerCase();

    listElements.each(function () {
        highlightMatchingText($(this), $(this).data("select-list-text"), searchValue)
    });
}

function highlightMatchingText(listItem, text, query) {
    var lowerText = text.toLowerCase();
    var isMatch = lowerText.includes(query);
    var currentIndex = 0;
    var content = $(document.createDocumentFragment());
    
    if (isMatch && query.length > 0) {
        var matchIndex = lowerText.indexOf(query);

        while (matchIndex != -1) {
            content.append(document.createTextNode(text.substring(currentIndex, matchIndex)));
            $("<span>")
                .addClass("search-list-match")
                .text(text.substring(matchIndex, matchIndex + query.length))
                .appendTo(content);

            currentIndex = matchIndex + query.length;
            matchIndex = lowerText.indexOf(query, currentIndex);
        }
    }

    content.append(document.createTextNode(text.substring(currentIndex)));
    listItem.toggleClass("d-none", !isMatch);
    listItem.empty().append(content);
}

export { validators, setupSelect };